// CommonJS syntax required
let errorMessagesTemplate = require('./errorMessages.template');

interface IDefaultErrorMessagesController {
    $templateRequest: ng.ITemplateRequestService;
    $compile: ng.ICompileService;
}

class DefaultErrorMessagesController implements IDefaultErrorMessagesController {
    static $inject = ['$compile', '$templateRequest'];
    constructor(public $compile : ng.ICompileService, public $templateRequest : ng.ITemplateRequestService) {        
    }
}

/**
 * @ngdoc directive
 * @name defaultErrorMessages
 * @module sharebase
 * @restrict E
 * @requires ngMessages
 * @description
 *
 * `defaultErrorMessages` inserts error messages to cover common form mistakes
 * @usage
 *
 * <div ng-messages="vm.form.customerName.$error" role="alert">
 *        <default-error-messages />
 * </div>
 *
 */
export function defaultErrorMessages(): ng.IDirective {
    return {
        restrict: 'E',
        require: ['^^ngMessages', 'defaultErrorMessages'],
        controller: DefaultErrorMessagesController,
        link: ($scope, element, attrs, controllers) => {
            let controller = <IDefaultErrorMessagesController>controllers[1];
            controller.$templateRequest(errorMessagesTemplate).then(function (html) {
                controller.$compile(html)($scope, function (contents) {
                    element.after(contents);
                    element.remove();
                });
            });
               
        }
    };
}




// WEBPACK FOOTER //
// ./src/sharebase/components/defaultErrorMessages/errorMessages.component.ts